import React from 'react';
import APPCONFIG from 'constants/Config';
import TextField from 'material-ui/TextField';
import QueueAnim from 'rc-queue-anim';
import FlatButton from 'material-ui/FlatButton';

import { push } from 'react-router-redux'

import { store } from '../../../stores/configureStore';
import { AUTHENTICATE_USER, SET_USER_ROLE, SET_USER_DETAILS } from '../../../constants/ActionTypes';

//services
import MessageService from '../../../services/MessageService'; var _mqtt = MessageService;
import DataService from '../../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../../services/LocalStorageService'; import { Dialog, RaisedButton } from 'material-ui';
var ls = LocalStorageService;

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      brand: APPCONFIG.brand,
      username: '',
      password: '',
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <RaisedButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };
    store.dispatch({ type: AUTHENTICATE_USER, auth: false })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  handlechanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleLogin(event) {
    event.preventDefault();
    if (!this.state.username || !this.state.password) {
      this.setState({
        dialog: {
          open: true,
          head: 'Fill all fields',
          body: 'Enter email and password to continue',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
    }
    else {
      let payload = {
        email: this.state.username,
        password: this.state.password,
        notification_id: ls.getNotificationIds(),
      };
      if (ls.getPartner()) {
        payload.partner = ls.getPartner();
      } else {
        let url = window.location.hostname;
        if(url != "https://hotel.kiot.io"){
          payload.partner_url = url;
        }
      }
      ds.postLogin(payload,
        data => {
          if (data && data.roles && data.roles.length) {
            data.user.roles = data.roles;
            if (data.user.hotel_id && data.hotel) {
              data.user.hotel = data.hotel;
            }
            ls.setUserDetails({ ...data.user, hostpitality_portal_url: data.hostpitality_portal_url });
            ls.setToken(data.token);
            store.dispatch({ type: SET_USER_DETAILS, user: data.user });
            store.dispatch({ type: AUTHENTICATE_USER, auth: true });
            store.dispatch({ type: SET_USER_ROLE, role: data.roles[0] });
            if (data.user.roles.indexOf('service_manager') != -1) {
              store.dispatch(push('/app/services/requests/all'));
            } else {
              store.dispatch(push('/app/dashboard'));
            }
          }
            _mqtt.connect(APPCONFIG.mqttUser, APPCONFIG.mqttPass,1);
        },
        error => {
          this.setState({
            dialog: {
              open: true,
              head: 'Error',
              body: error && error.data ? error.data.message : 'Some error occurred',
              actions: [
                <FlatButton
                  label="Okay"
                  primary
                  onClick={this.closeDialog.bind(this)}
                />
              ]
            }
          })
        });
    }
  }


  render() {
    return (
      <div className="body-inner">
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div>
          <div className="card-content">
            <section className="text-center">
              <h1>{this.state.brand}</h1>
            </section>

            <form className="form-horizontal customForm" onSubmit={this.handleLogin.bind(this)}>
              <fieldset>
                <div className="form-group">
                  <TextField
                    floatingLabelText="Email"
                    fullWidth
                    className="login-input"
                    value={this.state.username}
                    name="username"
                    onChange={this.handlechanges.bind(this)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    floatingLabelText="Password"
                    type="password"
                    fullWidth
                    className="login-input"
                    value={this.state.password}
                    name="password"
                    onChange={this.handlechanges.bind(this)}
                  />
                </div>
                <div className="card-action no-border text-right mb-2rem">
                  <RaisedButton disabled={this.state.username && this.state.password ? false : true}
                    label="LOGIN"
                    type="submit"
                    primary
                  >
                  </RaisedButton>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const Page = () => (
  <div className="page-login">
    <div className="main-body">
      <QueueAnim className="ui-animate">
        {
          // Not using now
          screen.width > 560 && 0 ?
            <div>
              <div className="pos-abs" style={{ marginTop: '2.7vw', marginLeft: '2.5vw' }}>
                <img src="assets/images/logo.png" className="h-4rem" />
              </div>

              <div className="pos-abs login-features" key="2">
                <div className="col-md-12">
                  <div className="col-md-4 align-center ">
                    <div> <img src="assets/images/link.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Link based check-in/out</div>
                  </div>

                  <div className="col-md-4 align-center">
                    <div> <img src="assets/images/switch.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Full-fledged room control</div>
                  </div>

                  <div className="col-md-4 align-center">
                    <div> <img src="assets/images/dashboard.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Extensive Power Consumption Analytics</div>
                  </div>
                </div>

                <div className="col-md-12 mt-4vw">
                  <div className="col-md-4 align-center">
                    <div> <img src="assets/images/support.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Live Hotel Service Monitor</div>
                  </div>

                  <div className="col-md-4 align-center">
                    <div> <img src="assets/images/promotions.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Push Hotel Promotions</div>
                  </div>

                  <div className="col-md-4 align-center">
                    <div> <img src="assets/images/finances.png" className="h-6-5rem ml-2rem" /></div>
                    <br />
                    <div className='customHeading ml-2rem'>Advanced Check-in stats</div>
                  </div>
                </div>

              </div>
            </div>
            : null
        }

        <div key="1" className="login-widget boxShadow">
          <Login />
        </div>

      </QueueAnim>
    </div>
  </div >
);

module.exports = Page;



// WEBPACK FOOTER //
// ./routes/login/components/Login.js